// The MarkDownDescription component is a reusable React component for rendering markdown content.
// It accepts two props: markdownText, which contains the markdown string to render, and classname for
// applying additional custom styles. The component uses the ReactMarkdown library to parse and display
// markdown content within a styled container. It provides a seamless way to integrate markdown-rendered
//  descriptions while maintaining consistent styling and flexibility for further customization.

import React from 'react';
import ReactMarkdown from 'react-markdown';

interface DescriptionProps {
  markdownText: string;
  classname?: string;
  Id?: string;
}

export const MarkDownDescription: React.FC<DescriptionProps> = ({ markdownText, classname = '', Id = '' }) => (
  <div className={`markdown-description ${classname}`} id={Id}>
    <ReactMarkdown>{markdownText}</ReactMarkdown>
  </div>
);
